<!-- Card-->
<div>
  <div *ngIf="showDealers && dealers.length > 0" class="card-dealers">
    <div class="d-flex">
      <i class="admin-icon-new-arramatar icon-card" style="margin-right: 8px">
      </i>

      <div class="title-card">Lojas Interessadas</div>
    </div>
    <div *ngFor="let dealer of dealers" class="dealer-margin">
      <app-dealer-interessed-info-box [dealer]="dealer"></app-dealer-interessed-info-box>
    </div>
  </div>
  <div style="margin-top: 8px" *ngIf="!loading">
    <div (click)="downloadDealersInfo()" class="see-dealers text-center pointer-hover underline" *ngIf="showDealers">
      Fazer download do CSV
    </div>
    <div (click)="showDealers = !showDealers; loadDealers()" class="see-dealers text-center pointer-hover underline">
      {{
        !showDealers
          ? "Ver lojas interessadas " + getVehicleTypeStr()
          : "Esconder lojas interessadas " + getVehicleTypeStr()
      }}
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="loading">
    <mat-spinner> </mat-spinner>
  </div>
</div>